module.exports = __webpack_public_path__ + "img/eyes_female_thin_makeup.dcac9aa3.png";